import { useCallback, useState } from 'react';

type DialogProps = {
  isOpen: boolean;
  onShow: () => void;
  onHide: () => void;
};

export const useDialogStatus = (): DialogProps => {
  const [isOpen, setIsOpen] = useState(false);

  const onShow = useCallback(() => setIsOpen(true), []);
  const onHide = useCallback(() => setIsOpen(false), []);

  return {
    isOpen,
    onShow,
    onHide,
  };
};
